import { render, staticRenderFns } from "./FerramentaContainer.vue?vue&type=template&id=de53cf04&scoped=true"
import script from "./FerramentaContainer.vue?vue&type=script&lang=js"
export * from "./FerramentaContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de53cf04",
  null
  
)

export default component.exports